"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _useFetch = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useFetch"));
var _useFilter = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useFilter"));
var _ProductDetailContext = _interopRequireDefault(require("../../../ProductDetail/context/ProductDetailContext"));
var _ProductSelectionContext = _interopRequireDefault(require("../../../ProductDetail/context/ProductSelectionContext"));
var _Select = _interopRequireDefault(require("./Select"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CombinationSelection = _ref => {
  let {
    displayedAttributes = [],
    lang
  } = _ref;
  const {
    REACT_APP_PATH
  } = process.env;
  const {
    attributes,
    combinationValues,
    productDetailData,
    setAttributes,
    setCombinationValues,
    setProductDetailData
  } = (0, _react.useContext)(_ProductDetailContext.default);
  const {
    setProductSelection
  } = (0, _react.useContext)(_ProductSelectionContext.default);
  const {
    defaultCombinationID: combinationID,
    id: productID
  } = productDetailData || {};
  const refForm = (0, _react.useRef)(null);
  const selection = (0, _useFilter.default)(refForm, {
    combinationID,
    productID
  });
  const {
    attributes: fetchedAttributes = {},
    combination = {},
    _loading = true
  } = (0, _useFetch.default)({
    data: JSON.parse(JSON.stringify(combinationValues)),
    url: "".concat(REACT_APP_PATH, "/Micado.Shop.Web/Micado.Shop.Web.IO.Api.ProductApi/CombinationSelection.api"),
    method: "GET"
  }, [combinationValues], !(0, _isEmpty.default)(combinationValues) && (combinationValues === null || combinationValues === void 0 ? void 0 : combinationValues.productID) && (combinationValues === null || combinationValues === void 0 ? void 0 : combinationValues.combinationID));
  (0, _react.useEffect)(() => {
    if ((0, _isEmpty.default)(fetchedAttributes)) return;
    setAttributes(fetchedAttributes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchedAttributes]);
  (0, _react.useEffect)(() => {
    var _selection$lang;
    const _combinationValues = JSON.parse(JSON.stringify(combinationValues));
    _combinationValues.combinationID = selection !== null && selection !== void 0 && selection.combinationID ? parseInt(selection.combinationID) : combinationID;
    _combinationValues.productID = selection !== null && selection !== void 0 && selection.productID ? parseInt(selection.productID) : productID;
    _combinationValues.lang = (_selection$lang = selection.lang) !== null && _selection$lang !== void 0 ? _selection$lang : lang;
    if (!(0, _isEmpty.default)(attributes)) {
      for (const key of Object.keys(attributes)) {
        const value = selection[key];
        if (value) _combinationValues[key] = value !== null && value !== void 0 ? value : "";
      }
    }
    setCombinationValues(prevCombinationValues => ({
      ...prevCombinationValues,
      ..._combinationValues
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [combinationID, productID, selection]);
  (0, _react.useEffect)(() => {
    if ((0, _isEmpty.default)(combination)) return;
    const {
      available,
      availableCount,
      combinationID
    } = combination || {};
    setProductSelection(prevProductSelection => ({
      ...prevProductSelection,
      combinationID,
      lang,
      productID
    }));
    setProductDetailData(prevProductDetailData => ({
      ...prevProductDetailData,
      ...combination,
      available,
      availableCount
    }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [combination]);
  const getValue = (0, _react.useCallback)(options => {
    var _options$find$id, _options$find;
    return (_options$find$id = options === null || options === void 0 || (_options$find = options.find(_ref2 => {
      let {
        selected
      } = _ref2;
      return selected;
    })) === null || _options$find === void 0 ? void 0 : _options$find.id) !== null && _options$find$id !== void 0 ? _options$find$id : "";
  }, []);
  const selectionAttributes = (0, _react.useMemo)(() => {
    if ((0, _isEmpty.default)(displayedAttributes)) return Object.keys(attributes);
    const identifier = [];
    for (const attribute in attributes) {
      if (displayedAttributes.indexOf(attribute) > -1) {
        identifier.push(attribute);
      }
    }
    return identifier;
  }, [attributes, displayedAttributes]);
  if ((0, _isEmpty.default)(fetchedAttributes)) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-shop-product-detail-combination-selection"
  }, /*#__PURE__*/_react.default.createElement("form", {
    ref: refForm
  }, combinationID && /*#__PURE__*/_react.default.createElement("input", {
    name: "combinationID",
    type: "hidden",
    value: combinationID
  }), productID && /*#__PURE__*/_react.default.createElement("input", {
    name: "productID",
    type: "hidden",
    value: productID
  }), selectionAttributes === null || selectionAttributes === void 0 ? void 0 : selectionAttributes.map(identifier => {
    const {
      items = [],
      title
    } = (attributes === null || attributes === void 0 ? void 0 : attributes[identifier]) || {};
    const value = getValue(items);
    return /*#__PURE__*/_react.default.createElement(_Select.default, {
      attributes: attributes,
      identifier: identifier,
      key: identifier,
      label: title,
      lang: lang,
      loading: _loading,
      options: items,
      value: value
    });
  })));
};
CombinationSelection.propTypes = {
  displayedAttributes: _propTypes.default.array,
  lang: _propTypes.default.string
};
var _default = exports.default = CombinationSelection;